(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('teamAddAction', {
      controller: Controller,
      templateUrl: 'actions/team/add/add-team.action.html',
      bindings: {
        then: '&',
        catch: '&'
      }
    });
}());
